const NAME = "CONTRACT_TYPES_SETTINGS";

export default NAME;
